module.exports = __webpack_public_path__ + "static/media/AOlogo.a654484c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AOlogo.png
// module id = 121
// module chunks = 0